export type ValidationResult = {
    valid: boolean,
    error: string | null,
    warning?: string | null,
};

const DOMAIN_REGEX = /^[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}$/;

export function normalizeDomain(input: string): string {
    return input.trim().toLowerCase().replace(/^@/, '');
}

export function validateDomain(input: string): ValidationResult {
    const trimmed = input.trim();

    if (trimmed.length === 0) {
        return {valid: false, error: 'Domain is required.'};
    }

    if (trimmed.length > 253 || trimmed.split('.').some(label => label.length > 63)) {
        return {valid: false, error: 'Domain is too long.'};
    }

    if (!DOMAIN_REGEX.test(trimmed)) {
        return {valid: false, error: 'Enter a valid domain (e.g., example.com).'};
    }

    return {valid: true, error: null};
}

export type DomainEntry = {
    value: string,
    verified: boolean,
    warning?: string | null,
    selected?: boolean,
};

export type VerifyDomainData = {
    domains: DomainEntry[],
};

export const INITIAL_DOMAIN_DATA: VerifyDomainData = {
    domains: [],
};

export function isDuplicateDomain(
    domain: string,
    existingDomains: DomainEntry[],
): boolean {
    const lower = domain.toLowerCase();
    return existingDomains.some(d => d.value.toLowerCase() === lower);
}

export const MAX_DOMAINS = 7;

export function isWarningPending(domain: DomainEntry): boolean {
    return domain.verified && domain.warning === undefined;
}

export function isDomainSelected(domain: DomainEntry): boolean {
    return domain.selected !== false;
}

export function getSelectedDomains(domains: DomainEntry[]): DomainEntry[] {
    return domains.filter(isDomainSelected);
}

export function areDomainsValid(domains: DomainEntry[]): boolean {
    const selected = getSelectedDomains(domains);
    return selected.length > 0
        && selected.length <= MAX_DOMAINS
        && selected.every(d => d.verified);
}
